import {create} from "zustand";
import {dynamicStateObjSlice} from "./Slices/DynamicStateObjSlice.ts";
import {settingsSlice} from "./Slices/SettingsSlice.ts";
import {environmentSlice} from "./Slices/EnvironmentSlice.ts";
import {userSlice} from "./Slices/UserSlice.ts";

export const useAppStore = create((set: any, get: any) => ({
    ...settingsSlice(set, get),
    ...environmentSlice(set, get),
    ...userSlice(set),
    ...dynamicStateObjSlice(set),
}));